import {Injectable} from '@angular/core';
import {WorkbenchPlugin, WorkbenchPluginId, WorkbenchViewConfig} from '../../shared/types';
import {WorkbenchLayoutManager} from '../../shared/services/workbench-layout-manager.service';
import {Observable, of} from 'rxjs';
import {faAcorn, faEnvelope} from '@fortawesome/pro-solid-svg-icons';
import {InspectorComponent} from '../../shared/components/inspector/inspector.component';
import {WorkbenchCommandRegistry} from '../../shared/services/workbench-command-registry.service';


@Injectable()
export class InspectorPlugin extends WorkbenchPlugin {
    id: WorkbenchPluginId = 'inspector';
    views: WorkbenchViewConfig<any>[];

    static readonly ViewContainerId: string = 'inspector.viewcontainer';
    static readonly InspectorViewId: string = 'inspector.view.inspector';

    constructor(readonly layoutManager: WorkbenchLayoutManager, private readonly commandRegistry: WorkbenchCommandRegistry) {
        super(layoutManager);
        this.views = [
            {
                id: InspectorPlugin.InspectorViewId,
                component: InspectorComponent,
                name: 'Inspector',
                defaultViewContainer: InspectorPlugin.ViewContainerId,
                expandedByDefault: true
            }
        ];
    }

    onWorkbenchDestroy() {
    }

    onWorkbenchInit(): Observable<void> {
        // We always open this viewContainer inside the initializePanels() from the workbench-layout-manager
        this.layoutManager.registerViewContainer({
            type: 'NormalViewContainer',
            id: InspectorPlugin.ViewContainerId,
            name: 'Inspector',
            icon: {
                type: 'faIcon',
                instance: faAcorn
            },
            allowedPanels: ['right'],
            defaultPanel: 'right',
            displayMode: 'standalone',
            moveAllowed: false,
            hideAllowed: false
        });

        //Commands
        this.commandRegistry.registerCommand(
            'inspector:toggleViewContainer',
            {
                statusBindings: {
                    'active': {
                        'type': 'store',
                        'storeKey': `viewcontainers.${InspectorPlugin.ViewContainerId}.status.visible`,
                    }
                }
            },
            () => {
                this.layoutManager.toggleViewContainer(InspectorPlugin.ViewContainerId, true);
            }
        );

        return of(undefined);
    }

}
